import { Box, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useState, ReactNode } from "react";

// 2023-24 imports
import annualday from "../../static_data/events2023_24/annualday.json";
import christmas from "../../static_data/events2023_24/christmas.json";
import farewell from "../../static_data/events2023_24/farewell.json";
import funfair from "../../static_data/events2023_24/funfair.json";
import msss from "../../static_data/events2023_24/msss.json";
import natioal_science_day from "../../static_data/events2023_24/national_science_day.json";
import republicday from "../../static_data/events2023_24/republicday.json";
import reopeningday23 from "../../static_data/events2023_24/reopening.json";

//2024-25 imports
import loyalafest24 from "../../static_data/events2024_25/loyalafest.json";
import reopeningday24 from "../../static_data/events2024_25/reopening.json";
import yoga24 from "../../static_data/events2024_25/yogaDay.json";
import ic24 from "../../static_data/events2024_25/ic.json";
import republicday25 from "../../static_data/events2024_25/republicDay.json";
import christmasday24 from "../../static_data/events2024_25/christmas_day.json";


//2025-26 imports
import reopening25 from "../../static_data/events2025_26/reopening.json";
import plantInaguration25 from "../../static_data/events2025_26/plantInaguration.json";
import StIgnatiusFeast25 from "../../static_data/events2025_26/StIgnatiusFeast.json";
import InvestitureCeremony25 from "../../static_data/events2025_26/investitureCeremony.json";
import guruPournima25 from "../../static_data/events2025_26/guruPournima.json";
import independenceDay25 from "../../static_data/events2025_26/independenceDay.json";
import scienceExhibition25 from "../../static_data/events2025_26/scienceExhibition.json";
import orientationForTeacher25 from "../../static_data/events2025_26/orientationForTeacher.json";
import TechersDay25 from "../../static_data/events2025_26/teachersDay.json";
import funfair2025 from "../../static_data/events2025_26/funFair2025.json";
import childrensDay2025 from "../../static_data/events2025_26/children'sDay2025.json";
import XestFest2025 from "../../static_data/events2025_26/XestFest2025.json";
import StFrancisXavierFeast from "../../static_data/events2025_26/StFrancisXavierFeast.json";
import annualsportsday2025 from "../../static_data/events2025_26/AnnualSportsDay2025.json";
import christmas25 from "../../static_data/events2025_26/ChristmasCelebration.json";
import annualDay25 from "../../static_data/events2025_26/AnnualDay2025.json";
import schoolReopen2026 from "../../static_data/events2026_27/schoolReopen.json";
import yogaDay2026 from "../../static_data/events2026_27/yogaDay.json";
import shahuJaynti2026 from "../../static_data/events2026_27/shahuJaynti.json";
import InvestitureCeremony2026 from "../../static_data/events2026_27/investitureCeremony.json";
import StIgnatiusofLoyolaFeastCelebration from "../../static_data/events2026_27/StIgnatiusofLoyolaFeastCelebration.json";
import ScienceExhibition from "../../static_data/events2026_27/ScienceExhibition.json";

//2026-27 imports
import THOMAS_SALVE_MEMORIAL_FOOTBALL_TOURNAMENT_2027 from "../../static_data/events2026_27/THOMAS_FOOTBALL_TOURNAMENT.json";


import ImgGallery from "../ImgGallery";

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
  color: string;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, color, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ backgroundColor: color, p: 1 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

type Props = {};

const Events = (props: Props) => {
  const [value, setValue] = useState(0);

  const [value_23_24, setValue2324] = useState(0);

  const [value_24_25, setValue2425] = useState(0);

  const [value_25_26, setValue2526] = useState(0);

  const [value_26_27, setValue2627] = useState(0);

  const events26_27 = [

     {
      imgArray: THOMAS_SALVE_MEMORIAL_FOOTBALL_TOURNAMENT_2027,
      title: "FR. THOMAS SALVE MEMORIAL FOOTBALL TOURNAMENT",
      date: "14-09-2026",
    },
    {
      imgArray: ScienceExhibition,
      title: "Science Exhibition",
      date: "14-08-2026",
    },
    {
      imgArray: StIgnatiusofLoyolaFeastCelebration,
      title: "St. Ignatius of Loyola Feast Celebration",
      date: "10-08-2026",
    },
    {
      imgArray: InvestitureCeremony2026,
      title: "Investiture Ceremony",
      date: "27-06-2026",
    },
    {
      imgArray: shahuJaynti2026,
      title: "Shahu Jayanti",
      date: "26-06-2026",
    },
    {
      imgArray: yogaDay2026,
      title: "Yoga Day",
      date: "21-06-2026",
    },
    {
      imgArray: schoolReopen2026,
      title: "School Reopen",
      date: "15-06-2026",
    },

  ]

  const events25_26 = [
    {
      imgArray: annualDay25,
      title: "Annual Day 2025",
      date: "30-12-2025",
    },
    {
      imgArray: christmas25,
      title: "Christmas Celebration 2025",
      date: "25-12-2025",
    },
    {
      imgArray: annualsportsday2025,
      title: "Annual Sports Day 2025",
      date: "05-12-2025",
    },
    {
      imgArray: StFrancisXavierFeast,
      title: "St. Francis Xavier Feast",
      date: "01-12-2025",
    },
    {
      imgArray: XestFest2025,
      title: "Xest Fest 2025",
      date: "20-11-2025",
    },
    {
      imgArray: childrensDay2025,
      title: "Childrens Day Celebration",
      date: "14-11-2025",
    },
    {
      imgArray: funfair2025,
      title: "Fun Fair 2025",
      date: "05-10-2025",
    },
    {
      imgArray: TechersDay25,
      title: "Teacher's Day Celebration",
      date: "05-09-2025",
    },
    {
      imgArray: orientationForTeacher25,
      title: "Orientation For Teacher",
      date: "25-08-2025",
    },
    {
      imgArray: scienceExhibition25,
      title: "Science Exhibition",
      date: "20-08-2025",
    },
    {
      imgArray: independenceDay25,
      title: "Independence Day ",
      date: "15-08-2025",
    },
    {
      imgArray: guruPournima25,
      title: "Guru Pournima",
      date: "10-07-2025",
    },
    {
      imgArray: InvestitureCeremony25,
      title: "Investiture Ceremony",
      date: "02-07-2025",
    },
    {
      imgArray: StIgnatiusFeast25,
      title: "Celebration of  St. Ignatius Feast",
      date: "30-06-2025",
    },
    {
      imgArray: plantInaguration25,
      title: "STP Plant Inaguration",
      date: "20-06-2025",
    },
    {
      imgArray: reopening25,
      title: "School Reopening Day",
      date: "15-06-2025",
    },

  ]

  const events24_25 = [
    {
      imgArray: loyalafest24,
      title: "St. Ignatius Loyola Fest",
      date: "02-08-2024",
    },
    {
      imgArray: reopeningday24,
      title: "Reopening Day",
      date: "03-06-2024",
    },
    {
      imgArray: yoga24,
      title: "Yoga Day",
      date: "22-06-2024",
    },
    {
      imgArray: ic24,
      title: "Investiture Ceremony",
      date: "01-07-2024",
    },
    {
      imgArray: republicday25,
      title: "Republic Day",
      date: "26-01-2025"
    },
    {
      imgArray: christmasday24,
      title: "Christmas Celebration",
      date: "25-12-2024"
    }
  ];
  const events23_24 = [
    {
      imgArray: annualday,
      title: "Annual Day",
      date: "23-07-2024",
    },
    {
      imgArray: christmas,
      title: "Christmas Day",
      date: "27-12-2023",
    },
    {
      imgArray: farewell,
      title: "Farewell Day",
      date: "17-05-2024",
    },
    {
      imgArray: funfair,
      title: "Fun Fair",
      date: "7-12-2023",
    },
    {
      imgArray: reopeningday23,
      title: "Reopening Day",
      date: "7-6-2023",
    },
    {
      imgArray: msss,
      title: "Sundar Shala Award from Maharashtra Govt.",
      date: "3-7-2023",
    },
    {
      imgArray: natioal_science_day,
      title: "National Science Day",
      date: "28-2-2024",
    },
    {
      imgArray: republicday,
      title: "Republic Day",
      date: "26-1-2024",
    },
  ];

  const parseDate = (dateStr: string): Date => {
    const [day, month, year] = dateStr.split("-").map(Number);
    return new Date(year, month, day);
  };
  const sortEventByDate = (
    events: Array<{ imgArray: any; title: string; date: string }>
  ) => {
    return events.sort(
      (a, b) => parseDate(a.date).getTime() - parseDate(b.date).getTime()
    );
  };
  const sortedEvent23_24 = sortEventByDate(events23_24).reverse();
  const sortedEvent24_25 = sortEventByDate(events24_25).reverse();
  const sortedEvent25_26 = sortEventByDate(events25_26).reverse();
  const sortedEvent26_27 = sortEventByDate(events26_27).reverse();

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };
  const handleChange2324 = (event: any, newValue: number) => {
    setValue2324(newValue);
  };
  const handleChange2425 = (event: any, newValue: number) => {
    setValue2425(newValue);
  };
  const handleChange2526 = (event: any, newValue: number) => {
    setValue2526(newValue);
  };
  const handleChange2627 = (event: any, newValue: number) => {
    setValue2627(newValue);
  };

  const tabBarSx = {
    width: "100%",
    minWidth: 0,
    "& .MuiTab-root": {
      whiteSpace: "nowrap",
    },
  };

  const renderEventTabs = (
    tabValue: number,
    onChange: (event: any, newValue: number) => void,
    events: Array<{ imgArray: any; title: string; date: string }>
  ) => (
    <>
      <Tabs
        value={tabValue}
        onChange={onChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="scrollable auto tabs example"
        sx={tabBarSx}
      >
        {events.map((heading, i) => (
          <Tab
            label={heading.title}
            key={heading.title + i + heading.date}
            sx={{ minWidth: "fit-content", width: "max-content" }}
          />
        ))}
      </Tabs>
      {events.map((single_event, i) => (
        <CustomTabPanel
          key={single_event.date + i + single_event.title}
          value={tabValue}
          index={i}
          color="white"
        >
          <ImgGallery
            title=""
            paddingLeft={0}
            imagesArray={single_event.imgArray.images}
            color="white"
          />
        </CustomTabPanel>
      ))}
    </>
  );

  return (
    <Stack direction="column" sx={{ width: "100%", minWidth: 0, maxWidth: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="scrollable auto tabs example"
        sx={tabBarSx}
      >
        <Tab label="2026-27" />
        <Tab label="2025-26" />
        <Tab label="2024-25" />
        <Tab label="2023-24" />
      </Tabs>
      <CustomTabPanel value={value} index={0} color="secondary.main">
        {renderEventTabs(value_26_27, handleChange2627, sortedEvent26_27)}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1} color="secondary.main">
        {renderEventTabs(value_25_26, handleChange2526, sortedEvent25_26)}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2} color="secondary.main">
        {renderEventTabs(value_24_25, handleChange2425, sortedEvent24_25)}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3} color="secondary.main">
        {renderEventTabs(value_23_24, handleChange2324, sortedEvent23_24)}
      </CustomTabPanel>
    </Stack>
  );
};

export default Events;
